import { localesMessages } from '@rfc/rfc-components-library/locales'

export const commonFr = {
    ...localesMessages.fr.common,
    confirmDelete: 'Confirmer la suppression',
    detail: 'Détail',
    noAction: 'Aucune action disponible',
    noData: 'Aucune donnée'
}
